import styled from "styled-components";

export const Label = styled.label`
  font-size: 10pt;
  font-family: "Roboto";
  font-weight: 500;
`;
